import {
    editLawyerController
  } from './controller';

  // <edit-lawyer-pop-up user_id="loggedInLawyer.user.user_ID" lawyer-id="loggedInLawyer.lawyer.lawyer_ID" logged-in-lawyer="loggedInLawyer" modal-firms="modalFirms" ref-selectivities="refSelectivities"
  //                 modal-categories="modalCategories" ref-employer-types="refEmployerTypes" is-lawyers-action-allowed-to-view="isLawyersActionAllowedToView"
  //                 success-call-back="callBackForLawyerEditPopup(updatedData,data)"></edit-lawyer-pop-up>
  
  const editLawyerPopUp = () => {
  
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        userId: '=',
        lawyerId: '=',
        loggedInLawyer:'=',
        modalFirms: '=',
        refSelectivities: '=',
        modalCategories: '=',
        refEmployerTypes: '=',
        currentPageItems: '=',
        isLawyersActionAllowedToView: '=',
        successCallBack: '&'
      },
      controller: editLawyerController,
      template: require('./template.html')
    }
  }
  
  angular
    .module('app.directives')
    .directive('editLawyerPopUp', editLawyerPopUp);


// WEBPACK FOOTER //
// ./scripts/shared/directives/actions-popup/directive.js